// extracted by mini-css-extract-plugin
export var buttons = "_bl-0";
export var buttonsActive = "_bl-h";
export var cancelConfirm = "_bl-1";
export var closeButton = "_bl-2";
export var column = "_bl-3";
export var container = "_bl-4";
export var detailHeader = "_bl-6";
export var detailTitle = "_bl-7";
export var detailsContent = "_bl-5";
export var header = "_bl-8";
export var headerWithClose = "_bl-9";
export var icon = "_bl-a";
export var infoIcon = "_bl-c";
export var informationContainer = "_bl-b";
export var sideDrawer = "_bl-d";
export var sideDrawerOpen = "_bl-e";
export var stickyFooter = "_bl-f";
export var typeOption = "_bl-g";